<template>
  <div>
    <Dialog
      :visible.sync="activityStatusForm1"
      :style="{ width: '640px', overflowY: 'auto' }"
      header="Activity Status Details"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="statusCode">Status Code*</label>
          <InputText
            id="statusCode"
            v-model.trim="activityStatus.statusCode"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !activityStatus.statusCode }"
            :disabled="disabledArr.includes('statusCode')"
          />
          <small
            class="p-invalid"
            v-if="submitted && !activityStatus.statusCode"
            >ActivityStatus Code is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="noteDetails">Color Code:</label>
          <Dropdown
            :showClear="true"
            v-model="activityStatus.colourCode"
            :options="colourCodes"
            optionLabel="label"
            dataKey="id"
            placeholder="Select Color Code"
            :disabled="disabledArr.includes('colourCode')"
          />
          <small
            class="p-invalid"
            v-if="submitted && !activityStatus.colourCode"
            >Status Colour Code is required.</small
          >
        </div>
      </div>

      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="statusName">Status Name*</label>
          <InputText
            id="statusName"
            v-model.trim="activityStatus.statusName"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !activityStatus.statusName }"
            :disabled="disabledArr.includes('statusName')"
          />
          <small
            class="p-invalid"
            v-if="submitted && !activityStatus.statusName"
            >ActivityStatus Name is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="lastName">Mark Active</label>
          <SelectButton
            v-model="activityStatus.active"
            :options="options"
            optionLabel="name"
          />
        </div>
      </div>

      <template #footer>
        <Button
          label="Reset"
          icon="pi pi-refresh"
          class="p-button-text"
          @click="reset"
        />
        <Button
          label="Save"
          icon="pi pi-check"
          class="p-button-text"
          @click="save"
        />
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-text"
          @click="cancel"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
export default {
  props: [
    "activityStatusToEdit",
    "activityStatusForm",
    "disabledArr",
    "colourCodes"
  ],
  data: () => ({
    activityStatus: {},
    submitted: false,
    options: [
      { name: "Active", value: true },
      { name: "Inactive", value: false }
    ]
  }),
  created() {
    if (this.activityStatusToEdit && this.activityStatusToEdit.id) {
      this.activityStatus = { ...this.activityStatusToEdit };
      this.activityStatusToEdit.active
        ? (this.activityStatus.active = { name: "Active", value: true })
        : (this.activityStatus.active = { name: "Inactive", value: false });
    }
  },
  computed: {
    activityStatusForm1: {
      set(val) {
        if (!val) {
          this.cancel();
        }
      },
      get() {
        return this.activityStatusForm ? true : false;
      }
    }
  },
  methods: {
    reset() {
      this.activityStatus = {};
    },
    save() {
      this.submitted = true;

      if (
        this.activityStatus.statusCode &&
        this.activityStatus.statusName &&
        this.activityStatus.colourCode
      ) {
        if (this.activityStatus.active instanceof Object) {
          this.activityStatus.active = this.activityStatus.active.value;
        }
        if (this.activityStatus.colourCode instanceof Object)
          this.activityStatus.colourCode = this.activityStatus.colourCode.value;

        this.$emit("save", this.activityStatus);
      }
    },
    cancel() {
      this.$emit("close");
    }
  }
};
</script>

<style></style>
